<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate>

    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
      </div>
      <div class="p-col-6 p-text-right">
        <button type="button" pButton [label]="t('partials.employee_search.topline')" icon="pi pi-search" (click)="onOpenEmployeeSearch()" class="p-button-sm p-button-secondary p-button-outlined p-mb-2 p-mr-4"></button>
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">

        <app-form-control [cid]="'gender'" [control]="form.get('gender')" [type]="'select'" [options]="salutations" [label]="t('common.labels.salutation')"></app-form-control>
        <app-form-control [cid]="'firstname'" [control]="form.get('firstname')" [type]="'input'" [label]="t('common.labels.firstname')"></app-form-control>
        <app-form-control [cid]="'lastname'" [control]="form.get('lastname')" [type]="'input'" [label]="t('common.labels.lastname')"></app-form-control>
        <!-- <app-form-control [cid]="'team'" [control]="form.get('team')" [type]="'select'" [label]="t('common.labels.team')" [options]="teams" [optionLabel]="'name'"></app-form-control> -->
        <app-form-control [cid]="'company'" [control]="form.get('company')" [type]="'input'" [label]="t('common.labels.company')"></app-form-control>

      </div>
      <div class="p-col-12 p-md-6">

        <app-form-control [cid]="'email'" [control]="form.get('email')" [type]="'input'" [label]="t('common.labels.email')"></app-form-control>
        <app-form-control [cid]="'phone'" [control]="form.get('phone')" [type]="'input'" [label]="t('common.labels.phone')"></app-form-control>
        <app-form-control [cid]="'mobile'" [control]="form.get('mobile')" [type]="'input'" [label]="t('common.labels.mobile')"></app-form-control>
        <app-form-control [cid]="'language'" [control]="form.get('language')" [type]="'select'" [options]="languages" [label]="t('common.labels.language')"></app-form-control>
        <app-country-timezone [edit]="true" [required]="true" [(country)]="country" [(timezone)]="timezone" [form]="this.form.get('tz')"></app-country-timezone>

      </div>

      <hr>
      <div class="p-col-12">
        <app-form-control [cid]="'comment'" [control]="form.get('comment')" [type]="'textarea'" [label]="t('common.labels.comment')"></app-form-control>
      </div>
    </div>

    <hr>
    <h2>{{ t('common.labels.roles') }}</h2>

    <div class="p-grid p-fluid">
      <div class="p-col-6">
        <app-form-control [cid]="'roles'" [control]="form.get('roles')" [type]="'multiselect'" [label]="t('common.labels.roles')" [options]="roles" [optionLabel]="'translated_rolename'"></app-form-control>
      </div>
    </div>

    <hr>
    <h2>{{ t('common.labels.password') }}</h2>

    <div class="p-grid p-fluid">
      <div class="p-col-6">
        <app-form-control [cid]="'password'" [control]="form.get('passwords.password')" [type]="'password'" [label]="t('common.labels.password')"></app-form-control>
      </div>
      <div class="p-col-6">
        <app-form-control [cid]="'confirm'" [control]="form.get('passwords.confirm')" [type]="'password'" [label]="t('common.labels.password_repetition')"></app-form-control>
      </div>
    </div>

  </form>

  <app-employee-search #employeesearch (select)="onSelectEmployee($event)"></app-employee-search>

</ng-container>
